import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useQuery } from '@sequencehq/api'

export const useQuoteData = (quoteId: string | undefined) => {
  const quoteQuery = useQuery(
    dashboard20240730Client.getQuote,
    { id: quoteId ?? '' },
    { enabled: !!quoteId }
  )

  const customerQuery = useQuery(
    dashboard20240730Client.getCustomer,
    { id: quoteQuery.data?.customerId ?? '' },
    { enabled: !!quoteQuery.data?.customerId }
  )

  return {
    quote: quoteQuery.data,
    customer: customerQuery.data,
    isPending: quoteQuery.isPending || customerQuery.isPending
  }
}
